import { createFileRoute } from "@tanstack/react-router";
import { EmailComposer } from "@/components/admin/disparos/EmailComposer";
import { z } from "zod";
import { seoHead } from "@/lib/seoHead";

export const Route = createFileRoute("/admin/marketing/newsletter")({
  validateSearch: z.object({ criar: z.literal("campanha").optional() }),
  head: () => seoHead({
    title: "Newsletter e campanhas | Shopping do Bem",
    description: "Crie e revise newsletters do Shopping do Bem com copy e imagens, acompanhe campanhas e envie testes.",
    path: "/admin/marketing/newsletter",
    noindex: true,
    ogImage: null,
  }),
  component: EmailComposer,
});
